import { ProjectTemplate } from "../../types";
import { Typography, Tooltip } from "antd";
import { Link } from "react-router-dom";
import { Crown } from "lucide-react";
import TemplateAvatar from "../TemplateAvatar";
import CloudIcon from "../CloudIcon";
import IaCIcon from "../IaCIcon";

const { Paragraph, Text } = Typography;

interface TemplateCardProps {
    template: ProjectTemplate;
}

const TemplateCard = ({ template }: TemplateCardProps) => {
    const isPremium = template.pack !== "free";
    const isMyTemplate = template.type === "component" && !template.public;

    return (
        <Link to={template.link || ""} className="template-card-link">
            <div className="template-card">
                {/* Header with icon and badge */}
                <div className="template-card-header">
                    <div className="template-card-icon">
                        <TemplateAvatar 
                            name={template.id} 
                            size={44} 
                            shape="square"
                            style={{ 
                                borderRadius: 10,
                                background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
                                padding: 8
                            }}
                        />
                    </div>
                    {isPremium && (
                        <Tooltip title="Premium template">
                            <div className="template-card-badge template-card-badge-premium">
                                <Crown size={12} />
                            </div>
                        </Tooltip>
                    )}
                    {isMyTemplate && (
                        <div className="template-card-badge template-card-badge-custom">
                            Custom
                        </div>
                    )}
                </div>

                {/* Title */}
                <Text strong className="template-card-name">
                    {template.name}
                </Text>

                {/* Description */}
                <Paragraph
                    ellipsis={{ rows: 2, tooltip: template.description }}
                    className="template-card-description"
                >
                    {template.description || <span className="template-card-no-desc">No description</span>}
                </Paragraph>

                {/* Spacer */}
                <div className="template-card-spacer" />

                {/* Footer with tech stack and author */}
                <div className="template-card-footer">
                    <div className="template-card-tags">
                        {template.cloudProvider && (
                            <Tooltip title={template.cloudProvider}>
                                <span className="template-card-tag">
                                    <CloudIcon provider={template.cloudProvider} />
                                </span>
                            </Tooltip>
                        )}
                        {template.iac && (
                            <Tooltip title={template.iac}>
                                <span className="template-card-tag">
                                    <IaCIcon provider={template.iac} />
                                </span>
                            </Tooltip>
                        )}
                    </div>
                    <Text className="template-card-author">
                        {template.owner?.name || "Microtica"}
                    </Text>
                </div>
            </div>
        </Link>
    );
};

export default TemplateCard;

